import { getFontSize, getColorAlias } from '../../../../utils/index.js';
import styled from 'styled-components';

const DaysOfWeek = styled.div `
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  margin: ${(props) => (props.narrow ? '0' : '0 16px')};
  overflow: hidden;
  padding-bottom: ${(props) => (props.narrow ? '8px' : '0')};
  border-bottom: ${(props) => props.narrow ? `1px solid rgba(0, 0, 0, 0.08)` : 'none'};
  padding-right: ${(props) => props.scrollBarWidth ? props.scrollBarWidth + 1 : 0}px;
`;
const DayName = styled.span `
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  ${getFontSize('size14')};
  font-weight: ${(props) => props.theme.font.weightRegular};
  color: ${getColorAlias('contentDisabled')};
  margin: 0 8px;
`;

export { DayName, DaysOfWeek };
